import { useEffect } from 'react';
import { useAuth } from '../../services/AuthContext';
import { loadAndApplyUserPreferences } from '../../services/userPreferences';

/**
 * Charge les préférences du compte connecté (API) à chaque session / changement d'utilisateur.
 */
export default function UserPreferencesSync() {
  const { user, loading } = useAuth();

  useEffect(() => {
    if (loading || !user?.id || !user?.role) return;
    loadAndApplyUserPreferences(user);
  }, [loading, user]);

  return null;
}
